<!--
 * @Author: Gaho
 * @Date: 2024-01-22 11:23:06
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-04 15:33:57
-->
<template>
    <div class="coinflip-bet-options">
        <div class="coinflip-toggle">
            <div class="flex items-center text-xs font-bold">
                <q-radio v-model="roundData.toggleValue"
                    :disable="bDisabledRadio"
                    val="instant"
                    dark size="xs"
                    :label="$t('instant')"
                    @update:model-value="(value) => handleToggleLocal(value)"
                />
                <q-radio v-model="roundData.toggleValue"
                    :disable="bDisabledRadio"
                    val="multiply"
                    dark size="xs"
                    :label="$t('multiply')"
                    @update:model-value="(value) => handleToggleLocal(value)"
                />
            </div>
            <!-- 
                左右分界 
            -->
            <Button class="button-bet bg-[#df123d]"
                v-if="toggleValue === 'multiply'"
                @click="handleBetOrBack"
                :disabled="betting || (coinFlipStore.betOrBack === 'bet' && coinFlipStore.accData.multi === 1)"
            >
                <p>
                    {{ betText }}
                </p>
                <span class="acc-amount">
                    {{ cashoutAmount }}
                </span>
            </Button>
        </div>
        <!-- 
            上下分界 
        -->
        <div class="form-options" :class="toggleValue === 'multiply' ? 'mode-1' : 'mode-0'">
            <div class="amount">
                <CasinoBetOptionSectionAmountOption :bet-amount-modal-value="betAmountModalValue" :betTookit="betTookit"
                    :is-submiting="coinFlipStore.betOrBack === 'bet' && toggleValue === 'multiply' ? true : isSubmiting" class="col-span-2"
                    @update:bet-amount-modal-value="emit('update:betAmountModalValue', $event)"
                    :gameName="useJoinStateStore().gameName" :sound="useSettingsStore().globalSounds" />
            </div>
            <Button mode="primary" class="button-head button-blue btn"
                :disabled="betting || (toggleValue === 'multiply' && coinFlipStore.betOrBack !== 'bet')"
                :class="{ 'button-blue': isSubmiting, 'button-grey': toggleValue === 'multiply' && coinFlipStore.betOrBack !== 'bet' }"
                @click="(e) => handleInstant(e, 'head')">
                <span class="text-xs">{{ $t('betHead') }}</span>
            </Button>
            <Button mode="primary" class="button-tail button-blue btn"
                :disabled="betting || (toggleValue === 'multiply' && coinFlipStore.betOrBack !== 'bet')"
                :class="{ 'button-blue': isSubmiting, 'button-grey': toggleValue === 'multiply' && coinFlipStore.betOrBack !== 'bet' }"
                @click="(e) => handleInstant(e, 'tail')">
                <span class="text-xs">{{ $t('betTail') }}</span>
            </Button>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'betOptions'
}
</script>
<script lang="ts" setup>
import { useCoinFlipStore } from '@/stores/cansino/coinflip';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import useSettingsStore from '~/stores/settings';
import type { useBettingToolkit } from '~/common/js/bettingToolkit';
const $t = useI18n().t;
const coinFlipStore = useCoinFlipStore();
// 下注、提现按钮文字内容
const betText = ref('');
const props = defineProps({
    betAmountModalValue: {// 投注金額
        type: Number,
        required: true
    },
    isSubmiting: {// 用於防止重複點擊,以及自動投注持續化條件
        type: Boolean,
        required: true
    },
    betSubmit: { // 投注方法
        type: Function as PropType<() => Promise<void>>,
        required: true
    },
    expectedReward: {// 預期獎勵
        type: Number,
        default: 0,
        required: false
    },
    toggleValue: { // Multiply或Instant模式
        type: String,
        required: true
    },
    handleInstant: {
        type: Function as PropType<(e: MouseEvent, type: 'head' | 'tail' | 'bet' | 'back') => void>,
        required: true
    },
    roundData: {
        type: Object,
        default: () => { }
    },
    betTookit: {
        // 投注工具包
        type: Object as PropType<ReturnType<typeof useBettingToolkit>>,
        required: true,
    },
    cashoutAmount: {
        type: String,
        default: ''
    },
    headTailAmount: {
        type: String,
        default: ''
    },
    betting: {
        type: Boolean,
        default: false
    },
    handleToggle: {
        type: Function as PropType<(type: 'instant' | 'multiply') => void>,
        required: true
    }
})

//记录单局、多局金额，使金额完全独立
const amountData = reactive({
    instant:0,
    multiply:0
})
const initAmountData = ()=>{
    if(props.toggleValue == 'instant'){
        amountData.instant = props.betAmountModalValue
    }else {
        amountData.multiply = props.betAmountModalValue
    }
}
initAmountData()
watch(()=>props.betAmountModalValue,()=>{
    initAmountData()
})
const emit = defineEmits([
    'update:betAmountModalValue',
    'update:isSubmiting',
    'update:betTargetModelValue'
]);

// 禁用 radio 
const bDisabledRadio = computed(()=>{
    const isPlaying = (
        props.toggleValue === 'multiply'
        && (
            coinFlipStore.betOrBack == 'bet' // 刚开局
            || Object.keys(coinFlipStore.accData).length // 已经押注 
        )
    );
    const bResult = !!(props.betting || isPlaying);
    return bResult; 
}); 

watch(
    [() => coinFlipStore.accData, () => props.toggleValue],
    (newVal) => {
        const accData = newVal[0];
        const toggleValue = newVal[1];
        if (accData && Object.keys(accData).length && toggleValue) {
            betText.value = $t('cashout').toLocaleUpperCase();
        } else {
            betText.value = $t('bet');
        }
    },
    {
        immediate: true,
        deep: true,
    },
);
const handleToggleLocal = (val: any) => {
    // console.log('mode changed to:', val); 
    switch (val) {
        case 'instant':
            emit('update:isSubmiting',false)
            if(amountData.instant > 0){
                emit('update:betAmountModalValue',amountData.instant)
            }
            props.handleToggle(val);
            break
        case 'multiply':
            if(props.betting || (coinFlipStore.betOrBack === 'bet' && coinFlipStore.accData.multi === 1)){
                emit('update:isSubmiting',true)
            }
            if(amountData.multiply > 0){
                emit('update:betAmountModalValue',amountData.multiply)
            }
            props.handleToggle(val);
            break
    }
}

/**
 * 多轮下注专用点击事件
 * @param e 
 */
const handleBetOrBack = (e: MouseEvent) => {
    // 返现
    if (Object.keys(coinFlipStore.accData).length) {
        coinFlipStore.betOrBack = 'back';
        props.handleInstant(e, 'back');
    } else {
        // 押注
        coinFlipStore.betOrBack = 'bet';
        props.handleInstant(e, 'bet');
    }
}
</script>

<style lang="scss" scoped>
.coinflip-bet-options {
    margin-top: 8px;

    .coinflip-toggle {
        display: grid;
        grid-template-columns: 50% 50%;
        min-height: 44px;

        :deep(.q-radio) {
            .q-radio__label {
                @media(max-width: 375px) {
                    font-size: 10px;
                }
            }
        }
    }

    .form-options {
        column-gap: 8px;
        display: grid;
        grid-template-columns: 48% 24% 24%;
        row-gap: 8px;
        margin-top: 8px;

    }

    .button-bet {
        border-radius: 7px;
        border: 1px solid transparent;
        border-radius: 7px;
        color: #fff;
        display: inline-block;
        font-style: normal;
        font-weight: 600;
        line-height: 1.4;
        position: relative;
        text-align: center;
        text-decoration: none;
        transition: all .3s;
        user-select: none;
        white-space: nowrap;
        font-size: 18px;

        .acc-amount {
            font-size: 12px;
            opacity: .8;
        }

        &:disabled {
            pointer-events: none;
        }
    }

    .button-head,
    .button-tail {
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        justify-content: center;
        min-height: 77px;
        border: 1px solid transparent;
        border-radius: 7px;
        color: #fff;
        display: inline-block;
        font-style: normal;
        font-weight: 600;
        line-height: 1.4;
        position: relative;
        text-align: center;
        text-decoration: none;
        transition: all .3s;
        user-select: none;
        white-space: nowrap;

        >span {
            &:nth-of-type(1) {
                margin-bottom: 5px;
                text-transform: uppercase;
            }

            &:nth-of-type(2) {
                opacity: .7;
            }

            @media(max-width: 375px) {
                font-size: 10px;
            }
        }
    }

    .button-head {
        padding-left: 77px;
        display: flex;

        &::after {
            left: 24px;
            background-image: url('~/assets/webp/coin-head.webp');
            background-position: 50%;
            background-size: 40px 40px;
            content: "";
            display: block;
            height: 40px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
        }

        @media (max-width: 1100px) {
            padding-right: 0px;
            padding-left: 0;

            &::after {
                left: 50%
            }
        }
    }

    .button-tail {
        padding-right: 77px;
        display: flex;

        &::after {
            right: 24px;
            background-image: url('~/assets/webp/coin-tail.webp');
            background-position: 50%;
            background-size: 40px 40px;
            content: "";
            display: block;
            height: 40px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
        }

        @media (max-width: 1100px) {
            padding-right: 0px;
            padding-left: 0;

            &::after {
                left: 50%
            }
        }
    }

    .button-grey {
        background-color: #1b2233;
        pointer-events: none;

        &:disabled {
            opacity: .4 !important;
        }
    }

    .button-blue {
        pointer-events: all;

        &:disabled {
            opacity: .4 !important;
        }
    }

    @media (max-width: 1100px) {

        .button-head,
        .button-tail {
            padding-top: 60px
        }
    }

    @media (max-width: 1100px) {

        .button-head:after,
        .button-tail:after {
            top: 15px;
            transform: translateX(-50%)
        }
    }

    @media (max-width: 576px) {
        .form-options {
            -moz-column-gap: 8px;
            column-gap: 8px;
            row-gap: 8px
        }
    }

}
</style>